//@ts-nocheck
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import StockPhotoImage from './StockPhotoImage';

export const PhotoCredit = ({ photo }) => {
  const { t } = useTranslation('common');
  const providerName = photo.provider
    ? photo.provider.charAt(0).toUpperCase() + photo.provider.slice(1)
    : '';
  const photographerName =
    photo.photographer || t('photoPicker.unknownPhotographer');

  return (
    <span className='photo-picker__credit'>
      {t('photoPicker.photoBy')}{' '}
      {photo.photographerUrl ? (
        <a
          href={photo.photographerUrl}
          target='_blank'
          rel='noopener noreferrer'
          onClick={(event) => event.stopPropagation()}
        >
          {photographerName}
        </a>
      ) : (
        photographerName
      )}{' '}
      {t('photoPicker.on')}{' '}
      {photo.photoPageUrl ? (
        <a
          href={photo.photoPageUrl}
          target='_blank'
          rel='noopener noreferrer'
          onClick={(event) => event.stopPropagation()}
        >
          {providerName}
        </a>
      ) : (
        providerName
      )}
    </span>
  );
};

PhotoCredit.propTypes = { photo: PropTypes.object.isRequired };

const StockPhotoGrid = ({
  photos,
  selected,
  remainingSlots,
  multiple,
  onSelect,
  loading,
  loadingMore = false
}) => {
  const { t } = useTranslation('common');
  const selectedIds = selected.map(
    (photo) => `${photo.provider}:${photo.providerPhotoId}`
  );
  const atCapacity =
    remainingSlots < 1 || (multiple && selected.length >= remainingSlots);

  return (
    <div className='photo-picker__grid' aria-busy={loading || loadingMore}>
      {loading
        ? Array.from({ length: 9 }, (_, index) => (
            <div
              className='photo-picker__skeleton'
              key={index}
              aria-hidden='true'
            />
          ))
        : photos.map((photo) => {
            const key = `${photo.provider}:${photo.providerPhotoId}`;
            const selectedIndex = selectedIds.indexOf(key);
            const disabled = atCapacity && selectedIndex === -1;
            return (
              <div
                className={`photo-picker__tile${disabled ? ' photo-picker__tile--disabled' : ''}`}
                key={key}
              >
                <button
                  type='button'
                  className={`photo-picker__tile-button${selectedIndex !== -1 ? ' photo-picker__tile-button--selected' : ''}`}
                  aria-label={photo.altText || t('photoPicker.photo')}
                  aria-pressed={selectedIndex !== -1}
                  disabled={disabled}
                  onClick={() => onSelect(photo)}
                >
                  <StockPhotoImage
                    key={`${photo.thumbnailUrl}:${photo.previewUrl}`}
                    sources={[photo.thumbnailUrl, photo.previewUrl]}
                    loading='lazy'
                  />
                  {selectedIndex !== -1 && (
                    <span className='photo-picker__number'>
                      {selectedIndex + 1}
                    </span>
                  )}
                </button>
                <PhotoCredit photo={photo} />
              </div>
            );
          })}
      {loadingMore &&
        Array.from({ length: 3 }, (_, index) => (
          <div
            className='photo-picker__skeleton'
            key={`more-${index}`}
            aria-hidden='true'
          />
        ))}
    </div>
  );
};

StockPhotoGrid.propTypes = {
  photos: PropTypes.arrayOf(PropTypes.object).isRequired,
  selected: PropTypes.arrayOf(PropTypes.object).isRequired,
  remainingSlots: PropTypes.number.isRequired,
  multiple: PropTypes.bool.isRequired,
  onSelect: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  loadingMore: PropTypes.bool
};

export default StockPhotoGrid;
